import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("[FocusController] Connected to DOM")
    this.restore()
    
    // 监听全局渲染事件
    this.renderHandler = this.restore.bind(this)
    document.addEventListener("turbo:render", this.renderHandler)
  }

  disconnect() {
    console.log("[FocusController] Disconnected")
    document.removeEventListener("turbo:render", this.renderHandler)
  }

  // 记录当前活跃的输入框 ID
  save(event) {
    const activeEl = document.activeElement
    if (activeEl && activeEl.id) {
      console.log(`[FocusController] Saving focus ID: ${activeEl.id}`)
      localStorage.setItem("persistent_focus_id", activeEl.id)
    } else {
      console.warn("[FocusController] No active element with ID found during save")
    }
  }

  restore() {
    const id = localStorage.getItem("persistent_focus_id")
    console.log(`[FocusController] Attempting to restore ID from storage: ${id}`)
    
    if (!id) return

    // 稍微延迟，等待 DOM 节点渲染完成并可用
    setTimeout(() => {
      const el = document.getElementById(id)
      if (el) {
        console.log(`[FocusController] Found element, applying focus to: ${id}`)
        el.focus()
        
        // 光标移至末尾
        if (el.setSelectionRange && el.value) {
          const len = el.value.length
          el.setSelectionRange(len, len)
        }
      } else {
        console.warn(`[FocusController] Element with ID '${id}' not found in current DOM`)
      }
    }, 100)
  }
}
